import React from "react";
import { useNavigate } from "react-router-dom";
import { IoSearchOutline } from "react-icons/io5";

export default function TitleSection({ hash, inputvalue, handleChange }) {
    const navigate = useNavigate();

    return (
        <div className="pt-4 px-2">
            <div className="grid grid-cols-8 relative items-center">
                <div className="col-span-8 flex justify-center">
                    <button className="bg-[#BDE6FF] rounded-lg text-black text-[12px] font-bold px-3 py-0.5 cursor-pointer">
                        #{hash}
                    </button>
                </div>
            </div>
            <div className="w-full flex justify-center items-center flex-col my-2">
                <div className="w-full flex relative">
                    <IoSearchOutline className="absolute left-[6px] top-1/2 transform -translate-y-1/2 cursor-pointer" />
                    <input
                        type="text"
                        placeholder="Search here"
                        value={inputvalue}
                        onChange={handleChange}
                        className="w-full outline-none rounded-full text-[14px] py-[6px] pl-7 pr-3 bg-gray-200 dark:bg-gray-800 text-black dark:text-white placeholder:text-gray-500"
                    />
                </div>
            </div>
        </div>
    );
}
